import { XMarkIcon, CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const variantStyles = {
  success: {
    bg: 'bg-green-50 border-green-200',
    text: 'text-green-800',
    icon: 'text-green-500',
    IconComponent: CheckCircleIcon
  },
  error: {
    bg: 'bg-red-50 border-red-200',
    text: 'text-red-800',
    icon: 'text-red-500',
    IconComponent: ExclamationCircleIcon
  },
  warning: {
    bg: 'bg-amber-50 border-amber-200',
    text: 'text-amber-800',
    icon: 'text-amber-500',
    IconComponent: ExclamationTriangleIcon
  },
  info: {
    bg: 'bg-blue-50 border-blue-200',
    text: 'text-blue-800',
    icon: 'text-blue-500',
    IconComponent: InformationCircleIcon
  },
  clear: {
    bg: 'bg-white border-gray-200',
    text: 'text-gray-800',
    icon: 'text-gray-500',
    IconComponent: InformationCircleIcon
  }
};

export default function Toast({ message, variant = 'clear', onDismiss }) {
  const style = variantStyles[variant] || variantStyles.clear;
  const IconComponent = style.IconComponent;

  return (
    <div className={`${style.bg} border rounded-lg shadow-lg p-4 flex items-start gap-3 min-w-[320px] animate-slide-in`}>
      <IconComponent className={`h-5 w-5 ${style.icon} flex-shrink-0 mt-0.5`} />
      <p className={`${style.text} flex-1 text-sm font-medium`}>{message}</p>
      <button
        onClick={onDismiss}
        className={`${style.text} hover:opacity-70 transition-opacity flex-shrink-0`}
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
